import { Component, ReactNode } from 'react'
import { ModalNodeProps } from '../../../components/modal.component'
import { Button, Radio, RadioChangeEvent } from 'antd'
import { toast } from 'react-toastify'
import { asyncDeleteBlockOff } from '../../../../services/booking.service'

export class RemoveRecurringBlockModal extends Component<
  ModalNodeProps,
  { blockId: string; date?: string; type: 'all' | 'dayOnly'; refreshSchedule?: () => void }
> {
  constructor(props: any) {
    super(props)
    const data = this.props.input
    this.state = {
      blockId: data.blockId,
      date: data.date,
      type: 'dayOnly'
    }
  }

  async removeBlock() {
    if (this.state.type === 'all') {
      try {
        await asyncDeleteBlockOff(this.state.blockId)
        this.props.input.refreshSchedule?.()
        this.props.onClose?.()
        toast.success('Removed')
      } catch (error: any) {
        const errorMessage = error.response?.data?.error?.message || error.message
        toast.error(`${errorMessage}`)
      }
    } else {
      try {
        await asyncDeleteBlockOff(this.state.blockId, this.state.date)
        this.props.input.refreshSchedule?.()
        this.props.onClose?.()
        toast.success('Removed')
      } catch (error: any) {
        const errorMessage = error.response?.data?.error?.message || error.message
        toast.error(`${errorMessage}`)
      }
    }
  }

  render(): ReactNode {
    return (
      <div className='remove-recurring-mode'>
        <div>
          <Radio.Group
            style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
            value={this.state.type}
            options={[
              { value: 'dayOnly', label: 'Selected Day only ' },
              { value: 'all', label: 'Selected Day & All Recurring' }
            ]}
            onChange={(e: RadioChangeEvent) => {
              this.setState({
                type: e.target.value
              })
            }}
          />
        </div>
        <div className='action'>
          <Button onClick={() => this.props.onClose?.()}>Cancel</Button>
          <Button type='primary' onClick={() => this.removeBlock()}>
            Ok
          </Button>
        </div>
      </div>
    )
  }
}
